import { fetchApiDataV2} from "../../utils/utils";

export const fetchWatchlistShows= async (appInfo) => {
    const api = "show/watchlistV2";
    return await fetchApiDataV2(appInfo,api)
}